package com.macrofocus.eflux.network.coordinate

import org.locationtech.jts.geom.Point

data class Coordinate(
    val coordinateId: String?,
    val physicalGeometry: Point?,
    val logicalGeometry: Point?,
    val seq: Int?,
    val probability: Double?,
    val risk_map: Int?,
    val risk_list: String?,
    val logicalBranchIds: String?,
    val description: String?,
    val t_70m: Double?,
    val wind_speed_70m: Double?,
    val wind_gusts_70m_1h: Double?,
    val precip_5min: Double?,
    val precip_type_intensity_5min: Double?,
    val forest_fire_warning: Double?,
    val power_line_oscillation_24h: Double?,
    val weather_code_1h: Double?,
    val tstorm_warning_1h: Double?,
    val air_density_70m: Double?,
    val count: Double?,
) {
}